import { render, staticRenderFns } from "./ClientPerformance.vue?vue&type=template&id=7e6984b8&scoped=true&"
import script from "./ClientPerformance.vue?vue&type=script&lang=js&"
export * from "./ClientPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6984b8",
  null
  
)

export default component.exports